import { z } from 'zod';

export const smsModalValidation = z.object({
  passowrd: z.string().min(4, { message: 'Введите корректный пароль' }),
});

export type SmsModalData = z.infer<typeof smsModalValidation>;
